import React, { useState, useEffect } from "react";
import axios from "axios";
import "./../styles/site.css";
import "./../styles/site/quest.css";
import NavbarTop from "./site/Navbartop";
import Footer from "./site/Footer";
import * as globals from "./../components/GlobalScripts.js";

const Checkout = () => {
    const path_api = localStorage.getItem("path_api");
    const [nextQuest_, setNextQuest_] = useState(false);
    const [formData, setFormData] = useState({
        edad: "",
        objetivo: "",
        restricciones: "",
        condicionesMedicas: "",
        actividadFisica: "moderado",
        alimentosPreferidos: "",
        alimentosEvitar: "",
        comidasDiarias: "",
        diasEntrenamiento: "3-4",
        lesion: "",
        tiempoSesion: "",
        experienciaEjercicio: "principiante",
        objetivoEntrenamiento: ""
    });

    useEffect(() => {
        globals.openViewCharge();
        get_quest();
    }, []);

    const get_quest = async () => {
        globals.validateSession();
        await axios
            .post(`${path_api}/site/get_quest.php`, {
                rute: globals.getRuteBackend(),
                session_id: globals.get_session_id(),
                keylogin: globals.get_keylogin()
            })
            .then((response) => {
                if (response.data.mensaje === "success") {
                    if(response.data.quest?.edad)
                        setFormData(response.data.quest);
                }else {
                    globals.createAlert({
                        type: "error",
                        msg_title: "Error",
                        msg: response.data.mensaje || "Sin comunicación con Danithor - log 1",
                        effect: "opacidad 2s, desplazamiento 2s",
                        time_life: 4000,
                    });
                }
            })
            .catch((error) => {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error 'log-account-1'",
                    msg: "Si persiste informa al soporte",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000,
                });
            });
        globals.closeViewCharge();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!nextQuest_) {
            setNextQuest_(true);
            return;
        }

        globals.validateSession();
        globals.openViewCharge();
        await axios
            .post(`${path_api}/site/update_quest.php`, {
                rute: globals.getRuteBackend(),
                session_id: globals.get_session_id(),
                keylogin: globals.get_keylogin(),
                quest: formData,
            })
            .then((response) => {
                if (response.data.mensaje === "success") {  
                    globals.createAlert({
                        type: "success",
                        msg_title: "Exito",
                        msg: "Cuestionario actualizado",
                        effect: "opacidad 2s, desplazamiento 2s",
                        time_life: 4000,
                    });
                    window.location.href = globals.getRuteGaleria();
                }else {
                    globals.createAlert({
                        type: "error",
                        msg_title: "Error",
                        msg: response.data.mensaje || "Sin comunicación con Danithor - log 2",
                        effect: "opacidad 2s, desplazamiento 2s",
                        time_life: 4000,
                    });
                }
            })
            .catch((error) => {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error 'log-account-2'",
                    msg: "Si persiste informa al soporte",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000,
                });
            });
        globals.closeViewCharge();
    };

    return (
        <div className="app-site app-container">
            <NavbarTop />
            <div className="main-content page-quest">
                <div className="page-container">
                    <div className="container-section small-section flex-column margin-top">
                        <div className="quest-form container-section banner white">
                        { !nextQuest_ && (
                            <form onSubmit={handleSubmit}>
                                <h2>Sobre tu dieta</h2>

                                <div className="form-group">
                                    <label htmlFor="edad">¿Cuál es tu edad?</label>
                                    <input
                                        type="text"
                                        id="edad"
                                        name="edad"
                                        value={formData.edad}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="objetivo">¿Cuál es tu objetivo principal con esta dieta?</label>
                                    <input
                                        type="text"
                                        id="objetivo"
                                        name="objetivo"
                                        placeholder="Perder peso, ganar músculo, mejorar la salud general, etc."
                                        value={formData.objetivo}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="restricciones">¿Tienes alguna restricción alimentaria o alergias?</label>
                                    <input
                                        type="text"
                                        id="restricciones"
                                        name="restricciones"
                                        placeholder="Intolerancias a lactosa, gluten, etc"
                                        value={formData.restricciones}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="condicionesMedicas">¿Tienes alguna condición médica que deba tenerse en cuenta?</label>
                                    <input
                                        type="text"
                                        id="condicionesMedicas"
                                        name="condicionesMedicas"
                                        placeholder="Diabetes, hipertensión, etc."
                                        value={formData.condicionesMedicas}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="form-group">
                                        <label htmlFor="actividadFisica">¿Cuál es tu nivel actual de actividad física?</label>
                                        <select
                                            id="actividadFisica"
                                            name="actividadFisica"
                                            value={formData.actividadFisica}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="sedentario">sedentario</option>
                                            <option value="moderado">moderado</option>
                                            <option value="intenso">intenso</option>
                                        </select>
                                    </div>

                                <div className="form-group">
                                    <label htmlFor="alimentosPreferidos">¿Qué tipo de alimentos prefieres o disfrutas más?</label>
                                    <input
                                        type="text"
                                        id="alimentosPreferidos"
                                        name="alimentosPreferidos"
                                        placeholder="Carnes, vegetales, frutas, etc."
                                        value={formData.alimentosPreferidos}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="alimentosEvitar">¿Hay algún alimento o grupo de alimentos que prefieras evitar?</label>
                                    <input
                                        type="text"
                                        id="alimentosEvitar"
                                        name="alimentosEvitar"
                                        placeholder="Por razones de gusto o dieta específica"
                                        value={formData.alimentosEvitar}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="comidasDiarias">¿Cuántas comidas realizas al día y a qué horas?</label>
                                    <input
                                        type="text"
                                        id="comidasDiarias"
                                        name="comidasDiarias"
                                        value={formData.comidasDiarias}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <button type="submit" className="button-primary">
                                    Siguiente
                                </button>
                            </form>
                        )}

                        { nextQuest_ && (
                            <form onSubmit={handleSubmit}>
                                <h2>Sobre tu rutina de entrenamiento</h2>

                                <div className="form-group">
                                    <label htmlFor="diasEntrenamiento">¿Cuántos días a la semana puedes o te gustaría entrenar?</label>
                                    <select
                                        id="diasEntrenamiento"
                                        name="diasEntrenamiento"
                                        value={formData.diasEntrenamiento}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="1-2">1-2</option>
                                        <option value="3-4">3-4</option>
                                        <option value="5-6">5-6</option>
                                        <option value="7">7</option>
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="lesion">¿Tienes alguna lesión previa o actual que deba tenerse en cuenta?</label>
                                    <input
                                        type="text"
                                        id="lesion"
                                        name="lesion"
                                        value={formData.lesion}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="tiempoSesion">¿Cuánto tiempo puedes dedicarle a cada sesión de entrenamiento?</label>
                                    <input
                                        type="text"
                                        id="tiempoSesion"
                                        name="tiempoSesion"
                                        value={formData.tiempoSesion}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="experienciaEjercicio">¿Cuál es tu experiencia previa con el ejercicio?</label>
                                    <select
                                        id="experienciaEjercicio"
                                        name="experienciaEjercicio"
                                        value={formData.experienciaEjercicio}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="principiante">Principiante</option>
                                        <option value="intermedio">Intermedio</option>
                                        <option value="avanzado">Avanzado</option>
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="objetivoEntrenamiento">¿Tienes algún objetivo específico con el entrenamiento?</label>
                                    <input
                                        type="text"
                                        id="objetivoEntrenamiento"
                                        name="objetivoEntrenamiento"
                                        placeholder="Aumentar masa muscular, mejorar resistencia, perder grasa, etc."
                                        value={formData.objetivoEntrenamiento}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <button type="submit" className="button-primary">
                                    Terminar
                                </button>
                            </form>
                        )}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Checkout;
